import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class CfdiUso extends FormComponent {

  componentDidMount() {
    const options = [{ 'Label': "Si", 'Value': 'Si' },{ 'Label': "No", 'Value': 'No' }]
    this.FormConfig(
      { defaultUrl: 'cfdi-uso/one', saveUrl: 'cfdi-uso/save', backUrl: '/Catalogo/CfdiUsos' },
      new Form([
        Form.Field('text', 'cfdi_uso_clave', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'cfdi_uso_nombre', 'Nombre', '', [Validators.required], 8),
        Form.Field('select', 'cfdi_uso_fisica', 'Fisica', '', [Validators.required], 6, options),
        Form.Field('select', 'cfdi_uso_moral', 'Moral', '', [Validators.required], 6, options),
      ], ['Guardar'], 'Uso CFDI'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CfdiUso)
